import React from "react";
import "./Banner.css";
import AboutBg from "../assets/Contact-banner.png"; // replace with your actual image path

export default function AboutHeader() {
  return (
    <section
      className="aheader-wrapper"
      style={{ backgroundImage: `url(${AboutBg})` }}
    >
      <div className="aheader-overlay">
        <h1 className="aheader-title">Contact Us</h1>
        <p className="aheader-breadcrumb">
          Home <span className="aheader-separator">›</span> Contact Us
        </p>
      </div>
    </section>
  );
}
